import React from "react";

/**
 * Bloco de detalhes bancários exibido no rodapé dos relatórios SOA.
 * Recebe os dados do banco selecionado e renderiza apenas os campos preenchidos.
 */
export default function BankingDetails({ bancoData }) {
  if (!bancoData) return null;

  const bankFields = [
    { label: "Bank's Name", value: bancoData?.Nome },
    { label: "Bank Code", value: bancoData?.Codigo },
    { label: "SWIFT Code", value: bancoData?.Swift },
    { label: "IBAN", value: bancoData?.Iban },
    { label: "Branch Number", value: bancoData?.Agencia },
    { label: "Account Number", value: bancoData?.Conta },
    { label: "Beneficiary", value: bancoData?.Beneficiario },
    { label: "Address", value: bancoData?.Endereco },
    { label: "CNPJ/CPF", value: bancoData?.Cnpj_Cpf },
    { label: "PIX", value: bancoData?.Pix },
    { label: "Correspondent Bank", value: bancoData?.Nome_Correspondente },
    { label: "Correspondent Address", value: bancoData?.Endereco_Correspondente },
    { label: "Correspondent Account", value: bancoData?.Conta_Correspondente },
    { label: "Correspondent SWIFT", value: bancoData?.Swift_Correspondente },
  ];

  const camposPreenchidos = bankFields.filter(
    (field) => field.value && field.value.toString().trim() !== ""
  );

  if (camposPreenchidos.length === 0) return null;

  return (
    <>
      <h5 style={{ width: "100%", textAlign: "center", marginTop: "20px" }}>
        BANKING DETAILS
      </h5>
      <table style={{ width: "80%", marginLeft: "5%", marginTop: "10px" }}>
        <tbody>
          {camposPreenchidos.map((field, index) => (
            <tr key={index}>
              <td style={{ padding: "2px 3px", paddingRight: 50 }}>
                <b>{field.label}:</b> {field.value}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}